export default __webpack_public_path__ + "static/article-finance-how-technology-can-help-hack-your-finances-4453fa6c29b475a6a594c8020bcec3b4.jpg";